import React from 'react'

const Contact = () => {
  return (
    <div>
      
      <a href='./Contact'>Contact</a>
    </div>
  )
}

export default Contact
